<template>
    <v-dialog
      v-model ="rejectdialogProp"
      persistent
      max-width="500"
    >
      <v-card class="pad-10">
        <!-- <v-card-title class=""> -->
          <p class="text-center"><b>Reject Trade </b></p>
          <p class="text-center font-weight-bold">*You are about <span class="red--text">rejecting</span> {{transaction.roomName}} Trade*</p>
        <!-- </v-card-title> -->
        
        <v-btn
            icon
            absolute
            top
            right
            @click="$emit('closeModal')"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        <v-card-text>
          <information-box
            :store="transaction.transaction.giftcard.store.name"
            :amount="Number(rejectedAmount)"
            :giftcard = "giftcardName"
            :rate = "transaction.transaction.giftcard.rate"
          />
          <label for="">Reason</label>
            <v-select :items="reasonList" v-model="reason"  outlined
              ></v-select>
            <label v-if="reason === 'Others'" for="" class="font-weight-medium">Enter Reason</label>
            <v-text-field v-if="reason === 'Others'" placeholder="Reason" color="auto" v-model="otherReason" type="text" outlined></v-text-field>
          <v-checkbox
            v-model="checkbox1"
            color="auto"
            label="Confirm you are about rejecting this trade"
            ></v-checkbox>
          <default-button :loading="loading" :disabled="!isComplete" @click="rejectTrade()">Reject Trade</default-button>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
// =============== IMPORT COMPONENT ==============
import DefaultButton from "@/components/Buttons/default-button.vue";
import InformationBox from "./information-box.vue"

// ================= IMPORT SERVICES ===============
import { StoresService } from "@/services";
import { CloseTradeEnum } from "@/enums"

export default {
    props:{
        rejectdialogProp:{
            type:Boolean,
        },
        transaction:{
          type:Object
        },
    },
    components: {
      DefaultButton,
      InformationBox
    },
    data: () => ({
      checkbox1:'',
      loading: false,
      reasonList: ['Invalid card', 'Redeemed card', 'Others'],
      reason: '',
      otherReason: ''
    }),
    computed:{
      isComplete() {
        return this.checkbox1
      },
      rejectedAmount(){
            if(this.transaction.transaction.loaderAmount){
                return this.transaction.transaction.loaderAmount
            }
            else{
                return this.transaction.transaction.userAmount
            }
      },
      giftcardName() {
        return `${this.transaction.transaction.giftcard.name} ${this.transaction.transaction.giftcard.country.cca2} (${this.transaction.transaction.giftcard.country.currencySymbol}${this.transaction.transaction.giftcard.cardMin}
} - ${this.transaction.transaction.giftcard.country.currencySymbol}${this.transaction.transaction.giftcard.cardMax})}`
      }
    },
    methods:{
      async rejectTrade(){
        try {
          this.loading = true;
          let payload = {
            trade : this.transaction.roomId,
            action : CloseTradeEnum.REJECT,
            reason: this.reason === 'Others' ? this.otherReason : this.reason
          }
          const data = await StoresService.closeTrade(payload);
          this.loading = false
          this.$emit('closeModal',payload.trade)
          console.log(data);
        } catch (error) {
          this.loading = false
          console.log(error);
        }
      }
    },
    
  watch:{
  },
}
</script>